angular.module('uti.skayo.onlinesale').controller('HelpController', function ($scope, $routeParams, $http) {


});